import { render } from "./ParallaxHero.vue?vue&type=template&id=49790c4d&scoped=true"
import script from "./ParallaxHero.vue?vue&type=script&lang=js"
export * from "./ParallaxHero.vue?vue&type=script&lang=js"

import "./ParallaxHero.vue?vue&type=style&index=0&id=49790c4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49790c4d"]])

export default __exports__